import { createContext, useContext, useState, useEffect } from "react";
import { supabase } from "@/lib/supabase";

export type SiteSettings = {
  site_title?: string;
  meta_description?: string;
  og_title?: string;
  og_description?: string;
  og_image_url?: string;
  og_url?: string;
  canonical_url?: string;
  keywords?: string;
  twitter_handle?: string;
  google_analytics_id?: string;
  clarity_id?: string;
  whatsapp?: string;
  linkedin?: string;
  instagram?: string;
  youtube?: string;
  facebook?: string;
  email?: string;
  phone?: string;
  address?: string;
};

const SiteDataContext = createContext<SiteSettings | null>(null);

export const useSiteData = () => useContext(SiteDataContext);

export const SiteDataProvider = ({ children }: { children: React.ReactNode }) => {
  const [settings, setSettings] = useState<SiteSettings | null>(null);

  useEffect(() => {
    supabase
      .from('SiteSettings')
      .select('*')
      .eq('id', 'global')
      .single()
      .then(({ data, error }) => {
        if (!error && data) setSettings(data as SiteSettings);
      });
  }, []);

  return (
    <SiteDataContext.Provider value={settings}>
      {children}
    </SiteDataContext.Provider>
  );
};
